<div class='merge-footer-line'>
    <div class="container">
        <div class="row">
            <div class="col-md-3">
                <div class='row'>
                    <div class="vs-card-logo">
                        <i class="material-icons vs-card-logo-font">playlist_add_check</i>
                    </div>
                    <div>
                        <div class="bold quote-title">{{ "quoteTracking.mergeQuotes" | cxTranslate }}</div>
                        <div class="quote-title">
                            {{ "quoteTracking.addQuotes" | cxTranslate }}
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-5">
                <div class='row'>
                    <div *ngFor="let item of getMaxArray(); let i = index" class='col-md-4'>
                        <div class="vs-card" *ngIf='quotes[i]?.quoteId'>
                            <div class="row">
                                <div class="col-8">        
                                    <div>{{ "quoteTracking.hashQuote" | cxTranslate }}</div>
                                    <div class="quote-number">
                                    {{ quotes[i].quoteId }}
                                    </div>
                                </div>
                                <div class="col-4 margin-auto">
                                    <i class="material-icons close-icon" (click)="closeCard(quotes[i], i)">close</i>
                                </div>
                            </div>
                        </div>
                        <div class="vs-card-placeholder" *ngIf='!quotes[i]?.quoteId'>
                            <div class="vs-card-placeholder-text">{{ "quoteTracking.addTo" | cxTranslate }}</div>
                            
                            <div class="vs-card-placeholder-text">{{maxLength - quotes.length}} {{ "quoteTracking.moreQuote" | cxTranslate }}</div>
                        </div>
                    </div>
                    
                </div>
            </div>
            <div class='col-md-4'>
                <div class="row">
                    <div class="col-8">
                        
                <button class="vs-primary-btn" [disabled]="quotes.length<2" (click)="proceedToMerge()"><i class="material-icons merge-icon">call_merge</i>{{ "quoteTracking.proceedMerge" | cxTranslate }}</button>
                    </div>
                    <div class="col-4">
                        
                <button class="vs-text-btn" (click)='discard()'>{{ "quoteTracking.discard" | cxTranslate }}</button>
                    </div>
                </div>
                
            </div>
        </div>
    </div>
</div>